import { type Editor } from '@tiptap/react';
import { Space } from 'antd';
import styled from 'styled-components';
import { ReferenceRichTextButton } from '../../../../../inputs/rich-text-advanced/menu-bar/ReferenceRichTextButton.tsx';
import { type IReference } from '../../../references/IReference.ts';
import { ComputeMathFunctionRichTextButton } from './ComputeMathFunctionRichTextButton.tsx';

// TODO Centralizzare
export const StyledSpace = styled(Space)`
  position: relative;
  z-index: 2;
`;

export interface IComputeExpressionMenuBarProps {
  editor: Editor | null;
  references: IReference[];
  noFunctions?: boolean;
}

export function ComputeExpressionMenuBar(
  props: IComputeExpressionMenuBarProps,
) {
  const { editor, references, noFunctions } = props;

  if (!editor) return null;

  return (
    <StyledSpace wrap size={2}>
      <ReferenceRichTextButton editor={editor} references={references} />
      {!noFunctions && <ComputeMathFunctionRichTextButton editor={editor} />}
    </StyledSpace>
  );
}
